const VALID_URL_REGEX = /^[a-z]+:\/\/([^/:]+)(:[0-9]+)?(\/.*)?$/i;

export function isUrlValid(value) {
  return VALID_URL_REGEX.test(value);
}
